import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import SectionHeader from "@/components/base/SectionHeader";
import Tag from "@/components/base/Tag";

export default function HotCharacters() {
  const hot = characters.slice(0, 5);
  const [lead, ...rest] = hot;

  return (
    <section aria-label="热门角色" className="mt-12 md:mt-16">
      <SectionHeader
        eyebrow="Characters"
        title="热门角色档案"
        subtitle="从调查记者到幕后操盘者，五位核心角色的动机与秘密，决定了整场谜局的走向。"
        action={
          <Link
            to="/characters"
            className="inline-flex items-center gap-2 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            全部角色档案
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        <Link
          to={`/characters/${lead.id}`}
          className="group relative rounded-lg overflow-hidden border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer min-h-[320px]"
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={lead.avatar}
              alt={`${lead.name} 角色形象`}
              title={`${lead.name} - 美国禁忌4 角色档案`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent" />
          <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-6">
            <Tag tone="accent">核心角色</Tag>
            <h3 className="mt-3 font-heading text-2xl text-foreground-950 group-hover:text-accent-400 transition-colors">
              {lead.name}
            </h3>
            <p className="font-label text-xs tracking-widest text-accent-400 mt-1 uppercase">{lead.enName}</p>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{lead.bio}</p>
          </div>
        </Link>

        <div className="flex flex-col gap-4 md:gap-5">
          {rest.map((ch) => (
            <Link
              key={ch.id}
              to={`/characters/${ch.id}`}
              className="group flex items-center gap-4 rounded-lg bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer p-3 md:p-4"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 rounded-md overflow-hidden">
                <img
                  src={ch.avatar}
                  alt={`${ch.name} 角色形象`}
                  title={`${ch.name} - 美国禁忌4 角色档案`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base text-foreground-950 group-hover:text-accent-400 transition-colors">
                    {ch.name}
                  </h3>
                  <Tag tone={ch.type === "反派" ? "accent" : "secondary"}>{ch.type}</Tag>
                </div>
                <p className="mt-1.5 text-[13px] text-foreground-500 leading-relaxed line-clamp-2">{ch.bio}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}